
<div class="modal-dialog nav-tabs-for-header-line" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Edit Asset</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body" *ngIf="loading">
      <error [error]="error"></error>
      <md-spinner-block></md-spinner-block>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <error [error]="error"></error>
      <nav class="nav nav-tabs nav-fill mb-3"><a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{active: page === &quot;details&quot;}" (click)="page = &quot;details&quot;">Details</a><a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{active: page === &quot;accessories&quot;}" (click)="page = &quot;accessories&quot;">Accessories</a><a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{active: page === &quot;contacts&quot;}" (click)="page = &quot;contacts&quot;">Contacts</a><a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{active: page === &quot;address&quot;}" (click)="page = &quot;address&quot;">Address</a><a class="nav-item nav-link" *ngIf="asset.isFutureFleet" href="javascript:void(0)" [ngClass]="{active: page === &quot;dates&quot;}" (click)="page = &quot;dates&quot;">Dates</a></nav>
      <div [hidden]="page !== &quot;details&quot;">
        <form [formGroup]="form">
          <!-- MAI / Lease / etc (future fleet) data display & product selection-->
          <div class="row" *ngIf="asset.isFutureFleet">
            <div class="form-group col">
              <label>DART Device</label>
              <select class="form-control" name="deviceId" formControlName="deviceId" autoLinkToLabel (change)="changedDartDevice()">
                <option *ngFor="let device of asset.availableDevices" [ngValue]="device.id">
                  {{ device.deviceKey }}
                   {{ device.productDescription }}
                   ({{ device.productNumber }})
                   - {{ device.disposition?.dispositionText || "Unknown disposition" }}
                </option>
              </select>
            </div>
          </div>
          <div class="row" *ngIf="asset.isFutureFleet">
            <div class="form-group col">
              <label>K2 Product, Model, and Family:</label>
              <select class="form-control" name="productId" formControlName="productId" autoLinkToLabel>
                <option *ngFor="let product of asset.availableProducts" [ngValue]="product.productId">
                  ID: {{ product.productId }}
                  , Model: {{ product.modelName }}
                  , Family: {{ product.familyName }}
                </option>
              </select>
            </div>
          </div>
          <!-- Removal / Ignore / etc (not future fleet) data entry & disposition selection-->
          <div class="row" *ngIf="!asset.isFutureFleet">
            <div class="form-group col-md-6">
              <label>Model Name:</label>
              <input class="form-control" type="text" name="modelName" formControlName="modelName" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Manufacturer:</label>
              <input class="form-control" type="text" name="manufacturer" formControlName="manufacturer" autoLinkToLabel>
            </div>
          </div>
          <div class="row" *ngIf="!asset.isFutureFleet">
            <div class="form-group col-md-6">
              <label>Product Number:</label>
              <input class="form-control" type="text" name="productNumber" formControlName="productNumber" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Disposition:</label>
              <select class="form-control" name="dispositionId" formControlName="dispositionId" autoLinkToLabel>
                <option *ngFor="let disposition of asset.dispositions" [ngValue]="disposition.id">{{ disposition.dispositionText }}</option>
              </select>
            </div>
          </div>
          <!-- Order details (and bulk order)-->
          <div class="row">
            <div class="form-group col-md-6">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="useBulkOrdering" formControlName="useBulkOrdering" autoLinkToLabel (change)="updateBulkOrderData()" [value]="false">
                <label class="form-check-label">Normal Order</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="useBulkOrdering" formControlName="useBulkOrdering" autoLinkToLabel (change)="updateBulkOrderData()" [value]="true" [attr.disabled]="!asset.availableBulkOrderItems?.length || null">
                <label class="form-check-label">Bulk Order</label>
              </div>
            </div>
            <div class="form-group col-md-6" *ngIf="form.value.useBulkOrdering">
              <label for="bulkOrderAssetId">Bulk Order Number:</label>
              <select class="form-control" id="bulkOrderAssetId" formControlName="bulkOrderAssetId" name="bulkOrderAssetId" (change)="updateBulkOrderData()">
                <option value=""></option>
                <option *ngFor="let item of asset.availableBulkOrderItems" [ngValue]="item.id">{{ item.orderNumber }} ({{ item.orderDate }}) - {{ item.quantityAvailable }}/{{ item.quantity }} available</option>
              </select>
            </div>
            <div class="col-md-6" *ngIf="!form.value.useBulkOrdering">
              <div class="row">
                <div class="col form-group">
                  <label>Order Number:</label>
                  <input class="form-control" type="text" name="orderNumber" formControlName="orderNumber" autoLinkToLabel>
                </div>
              </div>
              <div class="row">
                <div class="col form-group">
                  <label for="orderDate">Order Date:</label>
                  <div class="input-group">
                    <input class="form-control" id="orderDate" type="text" name="orderDate" formControlName="orderDate" [value]="form.value.orderDate">
                    <datepicker class="right input-group-append" formControlName="orderDate" name="orderDatePicker" [value]="form.value.orderDate"></datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Asset data (serial number, etc)-->
          <div class="row">
            <div class="form-group col-md-6">
              <label>Serial Number:</label>
              <input class="form-control" type="text" name="serialNumber" formControlName="serialNumber" autoLinkToLabel (input)="form.controls.serialNumber.setValue(form.controls.serialNumber.value.toUpperCase())">
            </div>
            <div class="form-group col-md-6">
              <label>Asset Tag:</label>
              <input class="form-control" type="text" name="assetTag" formControlName="assetTag" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Building:</label>
              <input class="form-control" type="text" name="building" formControlName="building" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Floor:</label>
              <input class="form-control" type="text" name="floor" formControlName="floor" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Floor Map ID:</label>
              <input class="form-control" type="text" name="floorMapId" formControlName="floorMapId" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Department:</label>
              <input class="form-control" type="text" name="department" formControlName="department" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>IP Address:</label>
              <input class="form-control" type="text" name="ipAddress" formControlName="ipAddress" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Gateway:</label>
              <input class="form-control" type="text" name="gateway" formControlName="gateway" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Subnet Mask:</label>
              <input class="form-control" type="text" name="subnet" formControlName="subnet" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Host Name:</label>
              <input class="form-control" type="text" name="hostName" formControlName="hostName" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>MAC Address:</label>
              <input class="form-control" type="text" name="macAddress" formControlName="macAddress" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Grid:</label>
              <input class="form-control" type="text" name="grid" formControlName="grid" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label for="installDate">Installation Date:</label>
              <div class="input-group">
                <input class="form-control" id="installDate" type="text" formControlName="installDate" [value]="form.value.installDate">
                <datepicker class="right input-group-append" formControlName="installDate" [value]="form.value.installDate"></datepicker>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>Source Name:</label>
              <input class="form-control" id="sourceName" type="text" name="sourceName" formControlName="sourceName" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <div class="form-check">
                <input class="form-check-input" id="hpInstalledKit" type="checkbox" formControlName="hpInstalledKit">
                <label class="form-check-label" for="hpInstalledKit">PM Kit Installed by HP</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6" *ngIf="asset.customHeading1">
              <label>{{ asset.customHeading1 }} (Custom 1):</label>
              <input class="form-control" type="text" formControlName="custom1" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.customHeading2">
              <label>{{ asset.customHeading2 }} (Custom 2):</label>
              <input class="form-control" type="text" formControlName="custom2" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.customHeading3">
              <label>{{ asset.customHeading3 }} (Custom 3):</label>
              <input class="form-control" type="text" formControlName="custom3" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.customHeading4">
              <label>{{ asset.customHeading4 }} (Custom 4):</label>
              <input class="form-control" type="text" formControlName="custom4" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.customHeading5">
              <label>{{ asset.customHeading5 }} (Custom 5):</label>
              <input class="form-control" type="text" formControlName="custom5" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.geoRegionId === 'EMEA'">
              <label>Custom 6:</label>
              <input class="form-control" type="text" formControlName="custom6" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.geoRegionId === 'EMEA'">
              <label>Custom 7:</label>
              <input class="form-control" type="text" formControlName="custom7" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.geoRegionId === 'EMEA'">
              <label>Custom 8:</label>
              <input class="form-control" type="text" formControlName="custom8" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.geoRegionId === 'EMEA'">
              <label>Custom 9:</label>
              <input class="form-control" type="text" formControlName="custom9" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6" *ngIf="asset.geoRegionId === 'EMEA'">
              <label>Custom 10:</label>
              <input class="form-control" type="text" formControlName="custom10" autoLinkToLabel>
            </div>
          </div>
        </form>
      </div>
      <div [hidden]="page !== &quot;accessories&quot;">
        <!-- Bundled accessory display-->
        <div class="row mb-2">
          <div class="col">
            <h4>Bundled Accessories:</h4>
            <p *ngIf="!asset.bundledAccessories.length">No bundled accessories exist on this asset.</p>
            <ng-template ngFor let-accessory [ngForOf]="asset.bundledAccessories" let-i="index">
              <h6 class="mb-2">{{ accessory.productNumber }} - {{ accessory.productDescription }}</h6>
              <div class="form-inline">
                <label>Serial Number:</label>
                <input class="form-control ml-1" type="text" (name)="&quot;textBundleAccessorySN&quot; + i" [(ngModel)]="accessory.serialNumber" (change)="accessory.changed = true" (ngModelChange)="accessory.serialNumber = $event.toUpperCase()" autoLinkToLabel>
              </div>
            </ng-template>
          </div>
        </div>
        <form role="form">
          <!-- Standalone accessories header (if present)-->
          <div class="row" *ngIf="asset.standaloneAccessories.length">
            <div class="col">
              <button class="btn btn-outline-primary btn-sm float-right" *ngIf="asset.availableStandaloneAccessories.length" (click)="addStandaloneAccessory()">Add New</button>
              <h4>Standalone Accessories:</h4>
            </div>
          </div>
          <div class="row" *ngIf="asset.standaloneAccessories.length">
            <div class="col">
              <p>Available standalone accessories may not be compatible with this asset.<br>Please verify your selections are compatible with this model.</p>
            </div>
          </div>
          <div class="row" *ngIf="asset.standaloneAccessories.length">
            <div class="col mb-3">
              <label for="preconfigurationServiceNumber">Preconfiguration Service Number:</label>
              <input class="form-control" id="preconfigurationServiceNumber" type="text" name="preconfigServiceNumber" [(ngModel)]="asset.preconfigServiceNumber">
            </div>
          </div>
          <!-- Standalone accessories header (if none present)-->
          <div class="row" *ngIf="asset.availableStandaloneAccessories.length &amp;&amp; !asset.standaloneAccessories.length">
            <div class="col">
              <button class="btn btn-outline-primary btn-sm float-right" *ngIf="asset.availableStandaloneAccessories.length" (click)="addStandaloneAccessory()">Add New</button>
              <h4>Standalone Accessories:</h4>
              <p>No standalone accessories have been added to this asset.</p>
            </div>
          </div>
          <!-- Standalone accessories list-->
          <div class="row" *ngFor="let accessory of asset.standaloneAccessories">
            <div class="col"><span [ngClass]="{&quot;remove-strike-item&quot;: !accessory.keep}">{{ accessory.productDescription }}
                <ng-template [ngIf]="accessory.serialNumber"> - {{ accessory.serialNumber }}</ng-template> ({{ accessory.productNumber }}, {{ accessory.deviceKey }})</span>
              <div class="btn-group float-right" *ngIf="accessory.keep">
                <button class="btn btn-outline-primary btn-sm float-right" (click)="editStandaloneAccessory(accessory)">Edit</button>
                <button class="btn btn-outline-danger btn-sm float-right" (click)="removeStandaloneAccessory(accessory)">Remove</button>
              </div>
              <div class="btn-group float-right" *ngIf="!accessory.keep">
                <button class="btn btn-outline-primary btn-sm float-right" (click)="accessory.keep = true">Re-Add</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div [hidden]="page !== &quot;contacts&quot;">
        <div class="row">
          <div class="col">
            <p><i>Changes to contacts are saved immediately.</i></p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="btn btn-outline-primary btn-sm float-right" role="button" (click)="editContact(&quot;toner&quot;)">Edit</button>
            <h4>Toner Contact:</h4>
            <ul>
              <li>Name: {{ asset.tonerContact.firstName }} {{ asset.tonerContact.lastName }}</li>
              <li>Email Address: {{ asset.tonerContact.emailAddress }}</li>
              <li>Phone Number: {{ asset.tonerContact.phoneNumber }}</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="btn btn-outline-primary btn-sm float-right" role="button" (click)="editContact(&quot;breakfix&quot;)">Edit</button>
            <h4>Breakfix Contact:</h4>
            <ul>
              <li>Name: {{ asset.breakfixContact.firstName }} {{ asset.breakfixContact.lastName }}</li>
              <li>Email Address: {{ asset.breakfixContact.emailAddress }}</li>
              <li>Phone Number: {{ asset.breakfixContact.phoneNumber }}</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="btn btn-outline-primary btn-sm float-right" role="button" (click)="editContact(&quot;installation&quot;)">Edit</button>
            <h4>Installation Contact:</h4>
            <ul>
              <li>Name: {{ asset.installationContact.firstName }} {{ asset.installationContact.lastName }}</li>
              <li>Email Address: {{ asset.installationContact.emailAddress }}</li>
              <li>Phone Number: {{ asset.installationContact.phoneNumber }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div [hidden]="page !== &quot;address&quot;">
        <div class="row">
          <div class="col">
            <p><i>Changes to addresses are saved automatically.</i></p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="border-info" *ngIf="asset.hpInstalledKit"><span class="oi oi-circle-check" style="margin-right: 5px"></span><b>PM Kit is going to be delivered here</b></div>
            <button class="btn btn-outline-primary btn-sm float-right" role="button" (click)="editAddress(&quot;service&quot;)">Edit</button>
            <h4>Custom Service address for this device</h4>
            <ul>
              <li>Address Name 1:<span>{{ asset.serviceAddress.name1 }}</span></li>
              <li>Address Name 2:<span>{{ asset.serviceAddress.name2 }}</span></li>
              <li>Address Line 1:<span>{{ asset.serviceAddress.line1 }}</span></li>
              <li>Address Line 2:<span>{{ asset.serviceAddress.line2 }}</span></li>
              <li>Region:<span>{{ asset.serviceAddress.region }}</span></li>
              <li>City:<span>{{ asset.serviceAddress.city }}</span></li>
              <li>Postal Code:<span>{{ asset.serviceAddress.postalCode }}</span></li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="border-info" *ngIf="!asset.hpInstalledKit"><span class="oi oi-circle-check" style="margin-right: 5px"></span><b>PM Kit is going to be delivered here</b></div>
            <button class="btn btn-outline-primary btn-sm float-right" role="button" (click)="editAddress(&quot;toner&quot;)">Edit</button>
            <h4>Custom Consumable address for this device</h4>
            <ul>
              <li>Address Name 1:<span>{{ asset.tonerAddress.name1 }}</span></li>
              <li>Address Name 2:<span>{{ asset.tonerAddress.name2 }}</span></li>
              <li>Address Line 1:<span>{{ asset.tonerAddress.line1 }}</span></li>
              <li>Address Line 2:<span>{{ asset.tonerAddress.line2 }}</span></li>
              <li>Region:<span>{{ asset.tonerAddress.region }}</span></li>
              <li>City:<span>{{ asset.tonerAddress.city }}</span></li>
              <li>Postal Code:<span>{{ asset.tonerAddress.postalCode }}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div [hidden]="page !== &quot;dates&quot;">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="datesTable">Dates</th>
              <th class="datesTable">Values</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">Installation Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.installDate">{{ asset.installDate }}</p>
              </td>
            </tr>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">Original Installation Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.installDate">{{ asset.installDate }}</p>
              </td>
            </tr>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">Contract Start Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.installDate">{{ asset.installDate }}</p>
              </td>
            </tr>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">EOT Lease Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.eotLeaseDate">{{ asset.eotLeaseDate }}</p>
              </td>
            </tr>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">Last Modified Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.updateDate">{{ asset.updateDate }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>